import React, { Component } from 'react';
import ReactGA from 'react-ga';

import Header from './Header';
import Footer from './Footer';
import MainView from './Views';
import { Categories, categories } from './Category';
import withArticleMetaData from './withArticleMetaData';

class SearchPage extends Component {
	componentDidMount() {
		ReactGA.initialize('UA-141772527-1');
		ReactGA.pageview(this.props.location.pathname);

	}
	componentDidUpdate(prevProps) {
		window.scrollTo(0, 0);
	}

	render() {
		const { posts } = this.props;
		const { field, value } = this.props.match.params;

		const filtered_posts = posts.filter(a => {
			return a[field].includes(value)
		})
		var fcolor = "#c9c9c9";
		if (categories[value] !== undefined)
			fcolor = categories[value].style.backgroundColor;

		const styled_value = (
			<span style={{color: fcolor}}>{value}</span>
		)

		return (
			<div >
				<Header image='/images/wallpaper/alps_cliff_blurred.jpg' >
					<div className='row'>
						<div className='group'>
							<h3>
								' union select * from articles where {field}="{styled_value}" --
								<br />
								<small>{filtered_posts.length} Result{filtered_posts.length != 1 ? "s" : ""}</small>
							</h3>
						</div>
					</div>
				</Header>
				<Categories />
				<MainView  posts={filtered_posts} />
			</div>
		);
	}
}

const Search = withArticleMetaData(SearchPage);

export default Search;



// WEBPACK FOOTER //
// ./src/Search.js